import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface LaundryRecDetailParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}
export interface receivedByNameList{
    receiver:string;
    count:number;
}

export interface LaundryRecDetail {
    id?: any;
    tenantId: any;
    branchId: any;
    laundryIssuedId:any;
    laundryItemId:any;
    receivedBy:any;
    receivedQty:number;
    rejectedQty:number;
    missingQty:number;
    receivedDate:Date;
    notes?:string;

    parameters?: LaundryRecDetailParameter[];
    links?: any;
}
export interface LaundryIssuedDetail{
   // [x: string]: any;
    id?:any;
    tenantId:any;
    branchId:any;
    laundryItemId?:any;
    issuedQty:any;
    laundryIssuedId:any;
   // totalQty:number;
}
export interface DashboardList{
laundryIssuedId:any;
receivedQty:number;
missingQty:number;
rejectedQty:number;
}

export abstract class LaundryRecDetailData {
   
    abstract list(url: string): Observable<LaundryRecDetail[]>;
    abstract create(url: string, data: LaundryRecDetail[]): Observable<any>;
    abstract update(url: string, data: LaundryRecDetail): Observable<any>;
    abstract delete(url: string): Observable<any>;
     abstract getById(url: string): Observable<LaundryRecDetail[]>;
     abstract listReceivedBy(url: string): Observable<receivedByNameList[]>;
      abstract dashboardList(url:string):Observable<DashboardList[]>;
}
